var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"News"},[(_vm.view_type === 'detail')?[_c('NewsDetail',{on:{"catchTitle":_vm.setTitle}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }